module.exports = __webpack_public_path__ + "media/LandingPageAssets/LouiseImage1-7bd41e47.png";